module.exports = __webpack_public_path__ + "static/media/absolute-active.ad6eb3eb.svg";